var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenseDraft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 2.625H3.5V3.5H8.75V2.625Z",
    fill: "#0066B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 4.375H3.5V5.25H8.75V4.375Z",
    fill: "#0066B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 6.125H3.5V7H6.125V6.125Z",
    fill: "#0066B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 10.5H3.5V11.375H5.25V10.5Z",
    fill: "#0066B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9968 8.44069L11.6843 7.12819C11.6437 7.08754 11.5955 7.0553 11.5424 7.03331C11.4893 7.01131 11.4325 6.99998 11.375 6.99998C11.3175 6.99998 11.2607 7.01131 11.2076 7.03331C11.1545 7.0553 11.1063 7.08754 11.0657 7.12819L7 11.1938V13.125H8.93117L12.9968 9.05931C13.0375 9.01871 13.0697 8.97049 13.0917 8.91741C13.1137 8.86434 13.125 8.80745 13.125 8.75C13.125 8.69255 13.1137 8.63566 13.0917 8.58259C13.0697 8.52951 13.0375 8.48129 12.9968 8.44069ZM8.56883 12.25H7.875V11.5562L10.0625 9.36867L10.7563 10.0625L8.56883 12.25ZM11.375 9.44383L10.6812 8.75L11.375 8.05617L12.0688 8.75L11.375 9.44383Z",
    fill: "#0066B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 13.125H2.625C2.39301 13.1248 2.17059 13.0325 2.00655 12.8684C1.84251 12.7044 1.75024 12.482 1.75 12.25V1.75C1.75024 1.51801 1.84251 1.29559 2.00655 1.13155C2.17059 0.967509 2.39301 0.875243 2.625 0.875H9.625C9.85699 0.875243 10.0794 0.967509 10.2434 1.13155C10.4075 1.29559 10.4998 1.51801 10.5 1.75V6.125H9.625V1.75H2.625V12.25H5.25V13.125Z",
    fill: "#0066B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseDraft);
export default __webpack_public_path__ + "static/media/licenseDraft.c843657118358143ea2da9082d3e7334.svg";
export { ForwardRef as ReactComponent };